import { useBoolean } from "ahooks";
import { Button, Input, Modal, Tag } from "antd";
import { ColumnsType } from "antd/lib/table";
import React, { useContext, useEffect, useState } from "react";
import { ButtonPanel } from "../../../../component/button-panel/button_panel";
import { DataTable } from "../../../../component/table";

import img_edit from "../../../../assets/images/bianji.png";
import img_see from "../../../../assets/images/chakan1.png";
import img_del from "../../../../assets/images/shanchu.png";
import { fileAction } from "../../action/equip/file_action";
import { FileStore } from "../../store/equip/file_store";
import { FormStoreProvider } from "../../store/equip/form_store";
import { Form } from "./form";
import { formAction } from "../../action/equip/form_action";
import { DataTableStore } from "../../../../component/table/store/data_table_store";
import { Search } from "../../../../component/search";
import { defualtPageSize, Progress } from "../../../../logic/common_logic";
import { AuthLogic } from "../../../../logic/auth_logic";
import { Control, See, Edit, Del } from "../../../../component/control-column";
import { ConfirmModal } from "../../../../component/modal";
import styles from "../../style/equip.module.scss";
let editId = "";
let seeId = "";
let item;
const formParams = {
  method: "Create",
  id: "",
};
export function EquipMent(viewPower) {
  const [createState, createFunc] = useBoolean(false);
  const [confirmState, confirmFunc] = useBoolean(false);
  const [checkStrictly, setCheckStrictly] = React.useState(false);
  const [deleteState] = useBoolean(false);
  const [] = useBoolean(false);
  const action = fileAction;
  const { state, dispatch } = useContext(FileStore);
  const { state: tableState, dispatch: tableDispatch } =
    useContext(DataTableStore);
  const [menuButton, setData] = useState([]);
  useEffect(() => {
    (async function () {
      let r = await new AuthLogic().selButton(viewPower.viewPower);
      if (r.length > 0) {
        for (let i = 0; i < r.length; i++) {
          r[i] = r[i].split("_")[r[i].split("_").length - 1];
        }
      }
      // console.log(r);

      setData(r);
    })();
    return () => {};
  }, []);
  const columns: ColumnsType = [
    {
      title: "操作",
      key: "1",
      align: "center",
      width: Control.width(3),
      render: Control.render(
        (v) =>
          menuButton.indexOf("VIEW") != -1 && (
            <See
              click={() => {
                editId = "";
                seeId = v.id;
                item = v;
                formParams.method = "View";
                createFunc.setTrue();
              }}
            />
          ),
        (v) =>
          menuButton.indexOf("UPDATE") != -1 && (
            <Edit
              click={() => {
                editId = v.id;
                seeId = "";
                item = v;
                formParams.method = "Edit";
                createFunc.setTrue();
              }}
            />
          ),
        (v) =>
          menuButton.indexOf("DELETE") != -1 && (
            <Del
              click={() => {
                formParams.id = v.id;
                confirmFunc.setTrue();
              }}
            />
          )
      ),
    },
    {
      title: "设备名称",
      dataIndex: "equipmentName",
      key: "2",
      align: "center",
    },
    {
      title: "IP地址",
      dataIndex: "ipAddress",
      key: "3",
      align: "center",
    },
    {
      title: "端口号",
      dataIndex: "port",
      key: "4",
      align: "center",
    },
    {
      title: "协议",
      dataIndex: "procType",
      key: "5",
      align: "center",
    },
  ];
  const onSearch = async (pageIndex) => {
    await action.loadPage({
      pageIndex: pageIndex,
      pageSize: defualtPageSize(),
      dispatch: tableDispatch,
      search: state.search,
    });
  };
  return (
    <div className={styles.root}>
      <Search>
        <Input
          maxLength={30}
          allowClear
          placeholder="请输入条码秤IP或别名"
          onChange={(e) =>
            action.setCondition({
              dispatch,
              key: "SearchKey",
              value: e.target.value,
            })
          }
        />
        <input type="button" value="快速查找" onClick={() => onSearch(1)} />
      </Search>
      <ButtonPanel>
        {menuButton.indexOf("ADD") != -1 && (
          <Button
            onClick={() => {
              formParams.id = "";
              formParams.method = "Create";

              editId = "";
              seeId = "";
              createFunc.setTrue();
            }}
          >
            新增条码秤
          </Button>
        )}
      </ButtonPanel>
      <DataTable
        columns={columns}
        action={fileAction}
        rowSelection={{ checkStrictly }}
        onLoad={async () => {
          await onSearch(1);
          Progress.done();
        }}
        onChange={(pageIndex) => {
          onSearch(pageIndex);
        }}
        scroll={{ scrollToFirstRowOnChange: true, autoY: true, x: 1060 }}
        loading={tableState.loading}
      />
      {createState && (
        <FormStoreProvider>
          <Form
            close={(hasUpdate) => {
              if (hasUpdate) {
                onSearch(tableState.current);
              }

              createFunc.setFalse();
            }}
            seeId={seeId}
            editId={editId}
            method={formParams.method}
            item={item}
          />
        </FormStoreProvider>
      )}

      <ConfirmModal
        visible={confirmState}
        title="温馨提示"
        subTitle="确认删除？"
        message="删除之后信息无法恢复，请慎重考虑"
        close={async (r) => {
          if (r) {
            await action.delRow({ dispatch, id: formParams.id });
            onSearch(tableState.current);
          }
          confirmFunc.setFalse();
        }}
      />
    </div>
  );
}
